import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }): string => theme.WHITE};
  border-radius: 13px;
  padding: 14px;
  margin: 20px 0px;
  font-family: Inter, sans-serif;
  font-weight: normal;
  font-size: 14px;
`;
export const Title = styled.div`
  font-weight: 500;
  font-size: 14px;
  margin: 15px 0px 28px 15px;
`;
